import { Skeleton } from '@design-system/Skeleton';
import { Card } from '@design-system/Card';
import { useIframeModeStore } from '@/hooks/useIframeModeStore';

export const SMPLandingPageSkeleton = () => {
  const { isIframeMode } = useIframeModeStore();

  return (
    <section
      className="page-container flex flex-col gap-6"
      data-testid="smp-skeleton"
    >
      {!isIframeMode && (
        <Skeleton className="h-6 w-16" data-testid="smp-skeleton-back" />
      )}

      {/* Header Card Skeleton */}
      <Card data-testid="smp-skeleton-header">
        <div className="p-6 flex flex-col gap-4">
          <Skeleton className="h-8 w-48" />
          <div className="flex items-center gap-3">
            <Skeleton className="h-5 w-32" />
            <Skeleton className="h-6 w-20 rounded-md" />
          </div>
          <Skeleton className="h-5 w-24" />
          <div className="flex gap-4">
            <div className="flex flex-col items-center gap-2">
              <Skeleton className="size-16 rounded-md" />
              <Skeleton className="h-4 w-20" />
              <Skeleton className="h-3 w-16" />
            </div>
            <div className="flex flex-col items-center gap-2">
              <Skeleton className="size-16 rounded-md" />
              <Skeleton className="h-4 w-20" />
              <Skeleton className="h-3 w-16" />
            </div>
            <div className="flex flex-col items-center gap-2">
              <Skeleton className="size-16 rounded-md" />
              <Skeleton className="h-4 w-20" />
              <Skeleton className="h-3 w-16" />
            </div>
          </div>
        </div>
      </Card>

      {/* Next Order Section Skeleton */}
      <Card data-testid="smp-skeleton-nextOrder">
        <div className="p-6 flex flex-col gap-3">
          <Skeleton className="h-6 w-36" />
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-4 w-28" />
        </div>
      </Card>

      {/* Manage Subscription Skeleton */}
      <Card data-testid="smp-skeleton-manage">
        <div className="p-6 flex flex-col gap-1">
          <Skeleton className="h-6 w-48 mb-3" />
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-12 w-full" />
          ))}
        </div>
      </Card>

      {/* Shipping & Payment Skeleton */}
      <Card data-testid="smp-skeleton-shipping">
        <div className="p-6 flex flex-col gap-1">
          <Skeleton className="h-6 w-40 mb-3" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
        </div>
      </Card>

      {/* Orders Skeleton */}
      <Card data-testid="smp-skeleton-orders">
        <div className="p-6 flex flex-col gap-1">
          <Skeleton className="h-6 w-24 mb-3" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
        </div>
      </Card>
    </section>
  );
};
